import { render, staticRenderFns } from "./sign-document-dialog.vue?vue&type=template&id=1ccfd856&"
import script from "./sign-document-dialog.vue?vue&type=script&lang=js&"
export * from "./sign-document-dialog.vue?vue&type=script&lang=js&"
import style0 from "./sign-document-dialog.vue?vue&type=style&index=0&id=1ccfd856&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports